import { SvgIcon } from '@mui/material';

const IconClose = (props) => {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path d="M18.295 16.885C18.6844 17.2744 18.6844 17.9056 18.295 18.295C17.9056 18.6844 17.2744 18.6844 16.885 18.295L12 13.41L7.115 18.295C6.72564 18.6844 6.09436 18.6844 5.705 18.295C5.31564 17.9056 5.31564 17.2744 5.705 16.885L10.59 12L5.705 7.115C5.31564 6.72564 5.31564 6.09436 5.705 5.705C6.09436 5.31564 6.72564 5.31564 7.115 5.705L12 10.59L16.885 5.705C17.2744 5.31564 17.9056 5.31564 18.295 5.705C18.6844 6.09436 18.6844 6.72564 18.295 7.115L13.41 12L18.295 16.885Z" />
    </SvgIcon>
  );
};

export default IconClose;
